module.exports = {
  apikey: require("./lib/apikey"),
  shannon: require("./lib/shannon")
};



//////////////////
// WEBPACK FOOTER
// ./~/apikeygen/dist/index.js
// module id = 500
// module chunks = 0